<template>
    <div class="main bg-waves">
        <section id="brn-contacts" class="diagonal">
            <BorderDecoration class="top-left" style="left: -10%"/>
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 intro">
                        <ChalkDecoration>
                            <h2 class="title" v-html="content['contacts-hero'].data.title"></h2>
                        </ChalkDecoration>
                        <p class="mt-5" v-html="content['contacts-hero'].data.text"></p>

                        <div v-if="content['contacts-hero'].data.contact_form !== undefined && content['contacts-hero'].data.contact_form">
                           <ContactForm :subject="content['contacts-hero'].data.title" />
                        </div>

                        <div class="my-5">
                            <p class="h5" v-if="settings.location !== undefined && !!settings.location.address">
                                <i class="bi bi-geo-alt text-secondary me-3"></i>
                                <a :href="'mailto:' + settings.location.address" class="text-dark">{{ settings.location.address }}</a>
                            </p>
                            <p class="h5">
                                <i class="bi bi-envelope-fill text-secondary me-3"></i>
                                <a :href="'mailto:' + settings.email" class="text-dark">{{ settings.email }}</a>
                            </p>
                            <p class="h5">
                                <i class="bi bi-telephone-fill text-secondary me-3"></i>
                                <a :href="'tel:' + settings.generalEnquiriesPhoneNumber" class="text-dark">{{ settings.generalEnquiriesPhoneNumber }}</a>
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <GoogleMap ref="map" @ready="getLocation">
                        </GoogleMap>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ChalkDecoration from "../components/elements/ChalkDecoration";
import PageLayoutContentMixin from "../../mixins/ContentMixin";
import SettingsMixin from "../../mixins/SettingsMixin";
import GoogleMap from "../components/elements/GoogleMap";
import ContactForm from "../components/forms/ContactForm.vue";


export default {
    name: "Contacts",
    components: {ContactForm, GoogleMap, ChalkDecoration},
    mixins: [PageLayoutContentMixin, SettingsMixin],
    methods: {
        getLocation() {
            this.$refs.map.addMarker({
                lat: parseFloat(this.settings.location.lat),
                lng: parseFloat(this.settings.location.lng)
            });
        }
    }
}
</script>

<style scoped>

</style>
